module.exports = __webpack_public_path__ + "static/img/layer_back.d2b7aae2.png";